import { Linkedin } from "lucide-react";

const LINKS = [
  { label: "Approach", href: "#belief" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Connect", href: "#connect" },
];

export default function Footer() {
  const handleNav = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer-section" className="border-t border-white/10 bg-noir text-cream">
      <div className="mx-auto w-full max-w-7xl px-6 pb-24 pt-20 md:px-12 md:pb-32 md:pt-28">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <a
            href="#top" onClick={(e) => handleNav(e, "#top")}
            className="inline-flex items-center transition-opacity hover:opacity-80"
          >
            <img
              src="/gv-logo-light.png"
              alt="Govil Ventures"
              className="w-auto"
              style={{ height: "clamp(2.25rem, 6vw, 4.5rem)" }}
            />
          </a>

          <nav className="flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.label} data-testid={`footer-link-${l.label.toLowerCase()}`}
                href={l.href} onClick={(e) => handleNav(e, l.href)}
                className="text-[0.72rem] font-medium uppercase tracking-[0.18em] text-cream/55 transition-colors hover:text-cream"
              >
                {l.label}
              </a>
            ))}
            <a
              data-testid="footer-linkedin"
              href="https://www.linkedin.com/company/govilventures/" target="_blank" rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="text-cream/55 transition-colors hover:text-gold"
            >
              <Linkedin className="h-5 w-5" strokeWidth={1.5} />
            </a>
          </nav>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-[0.72rem] uppercase tracking-[0.14em] text-cream/35">&copy; 2026 Govil Ventures</p>
          <p data-testid="footer-statement" className="max-w-md text-[0.72rem] uppercase tracking-[0.14em] text-cream/35">
            Experience is an unfair advantage. We compound it.
          </p>
        </div>
      </div>
    </footer>
  );
}
